import angular from 'angular';
import 'angular-bootstrap';
import 'leaflet';
import 'leaflet-draw';
import locales from '../../locale';
import './mapsServices';
import 'Leaflet.Snap';
import '../../../scripts/leaflet-label-shim';

const mapsControllers = angular.module('applicationModule.mapsControllers', [
    'applicationModule.mapsServices',
    'commonModule.localizationMapService',
    'ui.bootstrap'
]);

// Map Controller
mapsControllers.controller('MapController', ['$scope', '$rootScope', '$stateParams', '$modal', 'NgTableParams', 'AppsoupAPI', 'Permissions', 'LocalizationMapService', 'MapService', 'Map', function ($scope, $rootScope, $stateParams, $modal, NgTableParams, AppsoupAPI, Permissions, LocalizationMapService, MapService, Map) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('maps');
    $scope.application_id = $stateParams.application_id;
    $scope.drawEnabled = true;

    $scope.map = LocalizationMapService.initMap();

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Map.getList($scope.application_id, params._params).then(function (response) {
                if (response.success) {
                    $scope.isLoading = false;
                    $scope.points = response.points;
                    if (angular.isDefined($scope.points)) {
                        params.total(response.points.total);
                        params.count(response.points.per_page);
                        params.page(response.points.current_page);
                        return response.points.data;
                    }
                } else {
                    $rootScope.$broadcast('404');
                }
            }).finally(function () {
                LocalizationMapService.resetMap();
                $scope.points = LocalizationMapService.displayPoints($scope.points.data, $scope.writeAccess);
                $scope.map = LocalizationMapService.getMap();
                $scope.map.fireEvent('resize');
            });
        },
        counts: []
    });

    /**
     * Odpala rysowanie lokalizacji
     */
    $scope.newPoint = function () {
        $scope.drawEnabled = false;
        LocalizationMapService.enablePointDrawer();
    };

    /**
     * Przerywa rysowanie lokalizacji
     */
    $scope.cancel = function () {
        $scope.drawEnabled = true;
        LocalizationMapService.cancelElement();
        LocalizationMapService.cancelEdit();
    };

    /**
     * Edytuje wybrany punkt
     * @param point
     */
    $scope.selectPoint = function (point) {
        $scope.point = angular.copy(point);
        $scope.point.lat = parseFloat($scope.point.lat);
        $scope.point.lng = parseFloat($scope.point.lng);
        $('#map')[0].scrollIntoView(true);
        LocalizationMapService.changeView($scope.point.lat, $scope.point.lng);
        editPoint(point);
    };

    /**
     * Pobiera dane o punkcie
     * @param point
     */
    var editPoint = function (point) {
        Map.get(point.id, $scope.application_id)
            .then(function () {
                if (angular.isNullOrUndefined($rootScope.open)) {
                    $rootScope.open = true;
                    initModal('edit', point);
                }
            });
    };

    /**
     * Event po narysowaniu nowej lokalizacji
     */
    $scope.$on('elementDrawn', function (event, data) {
        var layer = data.layer;
        var point = [layer._latlng.lat, layer._latlng.lng];
        LocalizationMapService.disableLocalizationSelector();
        $scope.drawEnabled = true;
        if (angular.isDefinedNotEmpty(point)) {
            var point_loc = {
                lat: point[0],
                lng: point[1],
                app_id: $scope.application_id
            };
            initModal('create', point_loc, layer);
        }
    });

    /**
     * Event po kliku na lokalizację
     */
    $scope.$on('elementEdit', function (e, point) {
        if ($scope.drawEnabled) {
            editPoint(point);
        }
    });

    /**
     * Event po usunięciu lokalizacji
     */
    $rootScope.$on('elementRemoved', function (e, point) {
        angular.forEach($scope.points, function (p, index) {
            if (point.id == p.id) {
                $scope.points.splice(index, 1);
                LocalizationMapService.resetMap();
                LocalizationMapService.displayPoints($scope.points, $scope.writeAccess);
            }
        });

    });
    /**
     * Event po zapisaniu lokalizacji
     */
    $rootScope.$on('elementSaved', function (e, point, editMode) {
        var points = [];
        if (editMode) {
            angular.forEach($scope.points, function (p, index) {
                if (point.id == p.id) {
                    $scope.points[index] = point;
                }
            });
        } else {
            points = $scope.points;
            points.push(point);
            $scope.points = points;
        }
        LocalizationMapService.resetMap();
        LocalizationMapService.displayPoints($scope.points, $scope.writeAccess);
    });

    /**
     * Inituje modal obszaru
     * @param mode create|edit
     * @param {*} point obiekt obszary, w przypadku tworzenia obiekt z samym {map_position}
     * @param layer warstwa na której ma utworzyć nowy obszar - wymagane tylko przy tworzeniu
     */
    function initModal(mode, point, layer) {
        if (!$scope.writeAccess)
            return;
        if (angular.isUndefined(mode))
            mode = 'create';
        var data = {
            editMode: (mode !== 'create'),
            point: point
        };
        if (mode === 'create')
            data.layer = layer;
        var ModalInstance = $modal.open({
            templateUrl: 'views/application/maps/components/modal/point.tpl.html',
            controller: 'MarkerModalController',
            resolve: {
                modalData: function () {
                    return data;
                }
            }
        });
        ModalInstance.result.then(function (data) {
            $rootScope.open = null;
            if (data) {
                angular.forEach($scope.points, function (val, key) {
                    if (data.point.id == val.id) {
                        $scope.points[key] = data.point;
                    }
                }, $scope.points);
                LocalizationMapService.displayPoints($scope.points, true);
                $scope.$broadcast('show-errors-reset');
                $scope.drawEnabled = true;
            }
        }).catch(() => {});
    }

}]);

// Marker Modal Controller
mapsControllers.controller('MarkerModalController', ['$scope', '$modalInstance', 'modalData', 'growl', 'LocalizationMapService', '$rootScope', 'Map', '$filter', function ($scope, $modalInstance, modalData, growl, LocalizationMapService, $rootScope, Map, $filter) {
    'use strict';
    $scope.editMode = modalData.editMode;

    $scope.point = {};
    $scope.point = angular.copy(modalData.point);
    $scope.editMode = angular.copy(modalData.editMode);

    if (angular.isDefined($scope.point.lat)) {
        $scope.point.lat = parseFloat($scope.point.lat);
    }

    if (angular.isDefined($scope.point.lng)) {
        $scope.point.lng = parseFloat($scope.point.lng);
    }

    $scope.savePoint = function (point) {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.pointForm.$valid) {
            $scope.isLoading = true;

            Map.save(point, $scope.editMode).then(function (result) {
                let data = result.data;

                $scope.errorType = false;
                if (data.success) {
                    growl.success('MODULES.MAPS.SUCCESS.POINT.' + ($scope.editMode ? 'EDIT' : 'NEW'));
                    $rootScope.$broadcast('elementSaved', data.point, $scope.editMode);
                    $modalInstance.close(data);
                    $scope.$broadcast('show-errors-reset');
                } else if (data.error) {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error(data.error);
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.deletePoint = function (point) {
        if (angular.isDefined(point.id)) {
            $scope.isLoading = true;
            Map.remove(point.id)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.MAPS.SUCCESS.POINT.DELETE');
                        $rootScope.$broadcast('elementRemoved', point);
                        $modalInstance.dismiss(point);
                    } else if (data.error) {
                        growl.error(data.error);
                        $scope.formErrors = data.error;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        Map.tags($scope.point.app_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.tags = data.tags;
            }
        });
    };

    $scope.tags = [];

    $scope.cancel = function () {
        $rootScope.drawEnabled = true;
        $rootScope.open = null;
        $modalInstance.dismiss('cancel');
    };

    $scope.$on('modal.closing', function () {
        $rootScope.open = null;
    });

    $scope.inputErrors = {
        'name': [{error: 'required', msg: 'ERROR.REQUIRED'}],
        'description': [{error: 'required', msg: 'ERROR.REQUIRED'}],
        'image': [{error: 'required', msg: 'ERROR.REQUIRE.IMAGE'}],
        'lat': [{error: 'required', msg: 'ERROR.REQUIRE.LAT'}],
        'lng': [{error: 'required', msg: 'ERROR.REQUIRE.LNG'}]
    };
}]);

export default mapsControllers;
